import DumbTokenFieldBlock from './TokenFieldBlock.dumb';

/* ---------------------------------- Types --------------------------------- */

export interface TokenFieldBlockI {
    /** Handles changing the value of the input field */
    handleChange: (character: string) => void;

    /** Move focus to the previous input field */
    moveToPrevious: () => void;

    /** Value displayed in the input field */
    value: string;

    /** Denotes if the input field is in focus */
    isActive: boolean;
}

/* --------------------------- Build the Component -------------------------- */

const TokenFieldBlock = ({
    handleChange,
    moveToPrevious,
    value,
    isActive,
}: TokenFieldBlockI) => (
    <DumbTokenFieldBlock
        handleChange={handleChange}
        moveToPrevious={moveToPrevious}
        value={value}
        isActive={isActive}
    />
);

/* --------------------------- Export the Component ------------------------- */

export default TokenFieldBlock;
